import { Component, Input, EventEmitter, Output } from '@angular/core';
import { App, NavController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { EventTabsPage } from '../../pages/event/details/event-tabs/event-tabs';
import { EventDetailsModel, EventListModel, EventProvider } from '../../providers/event/event';
import { LoaderProvider } from '../../providers/loader/loader';
import { ConfigProvider } from '../../providers/config/config';
import { NewsController } from '../../providers/news/news-contoller';
import { AppDetectorProvider } from '../../providers/detector/detector';

/**
 * Generated class for the EventSearchListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'event-search-list-item',
  templateUrl: 'event-search-list-item.html'
})
export class EventSearchListItemComponent {

  @Input("event")
  event: any;

  @Input('pipeDateFormat')
  pipeDateFormat: any = "dd.MM.yyyy";

  @Input("openDetails")
  openDetails: boolean;

  @Input("order")
  order: boolean;

  @Output()
  onEvent: EventEmitter<string>;

  clientApp = false;
  newDesign = false;

  secondEntryLevel: boolean = false;
  mainColor: string = "black";

  constructor(
    public app: App,
    public translate: TranslateService,
    private eventService: EventProvider,
    private loadingCtrl: LoaderProvider,
    public appDetector: AppDetectorProvider,
    private config: ConfigProvider
  ) {
    new Promise(async (resolve, reject) => {
      this.onEvent = new EventEmitter<string>();
      let appId: string = (await this.config.config).appId;

      this.newDesign = (await this.config.config).showHide.newEventDesign;
      // this.newDesign = (this.newDesign) ? !this.openDetails : false;
      this.clientApp = (appId.includes('hella') || appId.includes('hannover') || appId.includes('frankfurt')) ? true : false;
      this.secondEntryLevel = (appId.includes('hella') || appId.includes('event')) ? true : false;
      this.mainColor = (await this.config.config).theme.color;
      // if (this.event && this.event.evtStat) this.timeCheck = (this.clientApp) ? (this.event.evtStat.includes('V') ? false : true) : true;
      // console.log(this.event);
    });
  }

  openEventDetails() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    NewsController.getInstance().isAllowed = false;

    this.eventService.getEventDetails(this.event.id).then((event: EventDetailsModel) => {

      if (event.name.length < 1) {
        this.openEventDetails();
        loader.dismiss();
      } else {
        (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
      }
    }).catch(err => loader.dismiss());
  }

  onEventPressed() {
    if (this.openDetails) {
      this.openEventDetails();
    } else {
      this.onEvent.emit(this.event.enaOrig);
    }
  }
}



// WEBPACK FOOTER //
// /src/components/event-search-list-item/event-search-list-item.ts